import React from 'react';
import { Box, VStack, Text, Icon } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import { InfoSection } from '../../components/profile/InfoSection';
import SettingSwitchRow from '../../components/mail/SettingSwitchRow';
import PageHeader from '../../components/base/PageHeader';
import { Tooltip } from '../../components/base/Tooltip';
import { useMailsSettings } from '../../hooks/useMailsSettings';

const MailSettingsPage: React.FC = () => {
    const { t } = useTranslation();
    const { settings, updateSettings, isLoading: isSettingsLoading, isSaving } = useMailsSettings();

    return (
        <Box h="calc(100vh - 20px)" bg="gray.100" px={4} pt={2} maxW="4xl" mx="auto" pb={{ base: 20, lg: 6 }}>
            {/* Заголовок */}
            <PageHeader title={t.pages.mail.incomingMailSettings} />

            <VStack gap={6} align="stretch" maxW={{ base: 'full', md: '600px' }} mx="auto">
                {/* Контент настроек */}
                <VStack gap={6} align="stretch">
                    {/* Раздел: Настройка сканирования */}
                    <InfoSection
                        title={t.pages.mail.scanningSettings}
                        isLoading={isSettingsLoading}
                        loadingLabel={t.pages.support.loading}
                        isUpdate={isSaving}
                        separator={false}
                        rightButton={
                            <Tooltip text={t.pages.mail.scanningSettingsPaperStorageTooltip}>
                                <Box
                                    cursor="pointer"
                                    p={1}
                                    borderRadius="full"
                                    _hover={{ bg: 'gray.200' }}
                                    transition="background-color 0.2s"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Icon as={FiInfo} color="yellow.600" boxSize={4} />
                                </Box>
                            </Tooltip>
                        }
                    >
                        <Text fontSize="md" color="gray.600">
                            {t.pages.mail.scanningDescription}
                        </Text>
                        <SettingSwitchRow
                            label={t.pages.mail.scanContent}
                            checked={settings?.scan_content ?? false}
                            onCheckedChange={(checked) => updateSettings({ scan_content: checked })}
                            disabled={isSaving}
                        />
                    </InfoSection>
                </VStack>
            </VStack>
        </Box>
    );
};

export default MailSettingsPage;
